import React from "react"
import { StaticQuery, graphql } from "gatsby"
import ColorLogo from "../assets/planet-argon-logo-color.png";

const Footer = () => (

  <StaticQuery
  query={graphql`
  {
    file(sourceInstanceName: {eq: "settings"}, name: {eq: "site-settings"}) {
      childMarkdownRemark {
        frontmatter {
          about_planet_argon
        }
      }
    }
  }
  `}
  render={data => (
    <footer className="is-footer">
      <div className="is-footer-container">
        <div className="columns is-footer-column is-desktop">
          <div className="column is-one-quarter-desktop footer-border-right py-6">
            <div className="is-footer-logo mt-5">
              Brought to you by
              <a href="http://www.planetargon.com" target="_blank">
                <img src={ColorLogo} />
              </a>
            </div>
          </div>
          <div className="column is-three-quarters-desktop has-footer-content py-6">
            <h3 className="title is-3 mt-5">About Planet Argon</h3>
            <div
              className="content mt-5"
              dangerouslySetInnerHTML={{ __html: data.file.childMarkdownRemark.frontmatter.about_planet_argon }}
            ></div>
            <a href="http://www.planetargon.com" target="_blank" rel="noopener noreferrer" className="button is-primary is-uppercase is-inline-block mb-6">Learn more about us</a>
          </div>
        </div>
      </div>
    </footer>
  )}
  ></StaticQuery>
)

export default Footer
